/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IProviderGroupSearchFilters } from 'app/cd/services/provider-service';

@autoinject
export class ProviderGroupFiltersCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public searchFilters: IProviderGroupSearchFilters = {};

    @bindable.string()
    public ariaLabelledbyId: string = '';

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected bind(): void {
        this.searchFilters.activeGroupsOnly = true;
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    protected toggleActiveGroupsOnly(value: boolean): void {
        this.searchFilters.activeGroupsOnly = value;
    }

    ////****************** Service Calls ********************************************////

}
